export function addScreenReaderHelper() {
  if (document.getElementById('a11y-screen-reader-style')) return;
  const style = document.createElement('style');
  style.id = 'a11y-screen-reader-style';
  style.textContent = `
    .a11y-sr-only {
      position: absolute !important;
      width: 1px !important;
      height: 1px !important;
      padding: 0 !important;
      margin: -1px !important;
      overflow: hidden !important;
      clip: rect(0, 0, 0, 0) !important;
      white-space: nowrap !important;
      border: 0 !important;
    }
  `;
  document.head.appendChild(style);
}

export function setAriaHidden(element, hidden) {
  if (element) {
    element.setAttribute('aria-hidden', String(hidden));
  }
}

export function announceRouteChange(routeName) {
  const announcer = document.getElementById('a11y-route-announcer');
  if (announcer) {
    announcer.textContent = `Navigated to ${routeName}`;
  }
}

export function createRouteAnnouncer() {
  if (document.getElementById('a11y-route-announcer')) return;
  const announcer = document.createElement('div');
  announcer.id = 'a11y-route-announcer';
  announcer.setAttribute('aria-live', 'polite');
  announcer.setAttribute('aria-atomic', 'true');
  announcer.className = 'a11y-sr-only';
  document.body.appendChild(announcer);
}
